import axios from "../../service/index";
import React, { Component } from "react";
import { Input, Select, Button, Divider, Table, Pagination, Modal, Form, message, Upload, Icon, Switch } from "antd";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "react-addons-update";
// import {component} from "../../commponents/tableRow"
import "./payClass.less";
const { Option } = Select;
const FormItem = Form.Item;
let qiniuUpUrl = "https://up-z1.qiniup.com";

class PayClass extends Component {
  state = {
    columns: [
      {
        title: "资源名称",
        dataIndex: "courseName",
        align: "left",
        key: "courseName",
      },
      {
        title: "学科名称",
        dataIndex: "subjectName",
        align: "left",
        key: "subjectName",
      },
      {
        title: "是否置顶",
        dataIndex: "isTop",
        key: "isTop",
        align: "center",
        render: (record, text) => {
          return (
            <div>
              <Switch
                defaultChecked={text.isTop === true ? true : false}
                key={text.isTop === true ? true : false}
                onChange={(checked) => {
                  this.topping(text, checked);
                }}
              />
            </div>
          );
        },
      },
      {
        title: "操作",
        align: "center",
        render: (row) => {
          return (
            <div className="all-btn">
              <Button
                type="link"
                onClick={() => {
                  this.handleKnow("edit", row);
                }}>
                编辑
              </Button>
              <Button
                type="link"
                className="red-color"
                onClick={() => {
                  Modal.confirm({
                    title: "删除",
                    okText: "确认",
                    cancelText: "取消",
                    content: "删除后将不可恢复，请谨慎操作！确定要删除吗？",
                    onOk: () => {
                      this.delStage(row.id);
                    },
                  });
                }}>
                删除
              </Button>
            </div>
          );
        },
      },
    ],
    dataSource: [],
    notChanged: [],
    total: 0,
    pageNum: 1,
    size: 10,
    courseName: "", // 资源名称
    isTop: undefined, // 置顶状态
    courseUrl: "", // 资源链接
    subjectId: undefined, // 学科
    optionList: [],
    detailObj: {},
    showKnowName: false,
    typeQ: "add",
    infourl: "",
    fileListloading: false,
    coverUrl: "", // 资源封面
    token: "",
  };
  componentDidMount() {
    this.getToken();
    this.InitCourse();
    this.InitClassHandle();
  }
  InitCourse() {
    axios.get("paycourse/manager").then((res) => {
      if (res.data.code === "200") {
        this.setState({ optionList: res.data.data });
      }
    });
  }
  getToken = () => {
    let _this = this;
    axios
      .get("/uplodController/get7menrToken")
      .then((res) => {
        if (res.data.code === "200") {
          _this.setState({
            token: res.data.data.token,
            infourl: res.data.data.url,
          });
        } else {
          message.error("七牛token获取失败");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  // 重置
  ClearKnow() {
    this.setState({ courseName: "", subjectId: undefined, isTop: undefined }, () => {
      this.InitClassHandle();
    });
  }
  // 查询列表
  InitClassHandle() {
    let { pageNum, size, courseName, subjectId, isTop } = this.state;
    axios.post("paycourse/list", { courseName, pageSize: size, pageNum, subjectId, isTop }).then((res) => {
      if (res.data.code === "200") {
        let data = res.data.data;
        this.setState({ total: data.total, notChanged: data.list, dataSource: data.list });
      }
    });
  }
  pageChange = (current) => {
    this.setState({ pageNum: current }, () => {
      this.InitClassHandle();
    });
  };
  sizeChange = (current, size) => {
    this.setState({ size }, () => {
      this.InitClassHandle();
    });
  };
  topping = (text, checked) => {
    axios
      .post("paycourse/toTop", {
        id: text.id,
        subjectId: text.subjectId,
        compulsion: false,
      })
      .then((res) => {
        if (res.data.code === "200") {
          let arr = this.state.dataSource;
          for (let i = 0; i < arr.length; i++) {
            if (text.id === arr[i].id) {
              arr[i].isTop = checked === true ? true : false;
              this.setState({
                dataSource: arr,
              });
            }
          }
          return Modal.confirm({
            title: `${checked === true ? "置顶" : "取消置顶"}`,
            okText: "确定",
            cancelText: "取消",
            content: (
              <div>
                <p>{checked === true ? "一个学科只能有一个资源置顶，确定要置顶吗？" : "取消置顶后用户端将按照既定规则排序，确定要取消置顶吗？"}</p>
              </div>
            ),
            onOk: () => {
              this.isRelease(text.id, checked, text.subjectId, "ok");
            },
            onCancel: () => {
              this.isRelease(text.id, checked, text.subjectId, "cancel");
            },
          });
        } else {
          let arr = this.state.dataSource;
          for (let i = 0; i < arr.length; i++) {
            if (text.id === arr[i].id) {
              arr[i].isTop = checked === true ? true : false;
              this.setState({
                dataSource: arr,
              });
            }
          }
          return Modal.confirm({
            title: `${checked === true ? "置顶" : "取消置顶"}`,
            okText: "确定",
            cancelText: "取消",
            content: (
              <div>
                <p>{res.data.msg}</p>
              </div>
            ),
            onOk: () => {
              this.isforceRelease(text.id, checked, text.subjectId, "ok");
            },
            onCancel: () => {
              this.isforceRelease(text.id, checked, text.subjectId, "cancel");
            },
          });
        }
      });
  };
  isRelease = (id, checked, subjectId, type) => {
    if (type === "cancel") {
      this.InitClassHandle();
    } else {
      const params = {};
      if (checked) {
        params.id = id;
        params.subjectId = subjectId;
        params.compulsion = false;
      } else {
        params.id = id;
      }
      axios.post("paycourse/toTop", params).then((res) => {
        if (res.data.code === "200") {
          message.success(`${checked === true ? "置顶成功" : "取消置顶成功"}`);
          this.InitClassHandle();
          Modal.destroyAll();
        } else {
          message.error(res.data.msg);
        }
      });
    }
  };
  isforceRelease = (id, checked, subjectId, type) => {
    if (type === "cancel") {
      this.InitClassHandle();
    } else {
      axios
        .post("paycourse/toTop", {
          id: id,
          subjectId: subjectId,
          compulsion: true,
        })
        .then((res) => {
          if (res.data.code === "200") {
            message.success(`${checked === true ? "置顶成功" : "取消置顶成功"}`);
            this.InitClassHandle();
            Modal.destroyAll();
          } else {
            message.error(res.data.msg);
          }
        });
    }
  };
  // 新增/编辑
  handleKnow = (type, obj) => {
    this.setState({ typeQ: type, detailObj: obj, showKnowName: true }, () => {
      if (type === "edit") {
        this.getTypeInfo(obj);
      }
    });
  };
  getTypeInfo() {
    let { detailObj } = this.state;
    this.setState({
      coverUrl: detailObj.coverUrl || "",
      // coverUrl: {
      //   uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ',
      //   type: 'image/png' || 'image/jpg' || 'image/jpeg',
      //   url: obj.coverUrl || '',
      //   name: obj.name
      // },
    });
    this.props.form.setFieldsValue({
      coverUrl: [{ url: detailObj.coverUrl || "", uid: "FirjdGoj0FyX6rVCgEPzouRC78dJ" || "", type: "image/png" || "image/jpg" || "image/jpeg", name: detailObj.name || "" }],
    });
  }
  // 删除
  delStage(id) {
    axios.get(`paycourse/delete/${id}`).then((res) => {
      if (res.data.code !== "200") return message.error(res.data.msg);
      message.success("删除成功");
      this.InitClassHandle();
    });
  }

  moveRow = (dragIndex, hoverIndex) => {
    let { dataSource } = this.state;
    const dragRow = dataSource[dragIndex];
    this.setState(
      update(this.state, {
        dataSource: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        },
      })
    );
    let oldSort = [];
    for (let i = 0; i < this.state.notChanged.length; i++) {
      oldSort.push({ sort: this.state.notChanged[i].sort, id: this.state.dataSource[i].id });
    }
    axios.post("/paycourse/update/sort", oldSort).then((res) => {
      if (res.data.code === "200") {
        oldSort = [];
      }
    });
  };

  submitOk = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if ("url" in values.coverUrl[0]) {
        if (!values.coverUrl[0].url) return message.error("请上传资源封面");
      } else {
        if (!values.coverUrl[0].response || !values.coverUrl[0].response.hash) return message.error("请上传资源封面");
      }
      if (!err) {
        let { typeQ, infourl, detailObj } = this.state;
        let params = {
          subjectId: values.subjectId,
          courseName: values.courseName,
          coverUrl: values.coverUrl[0].url ? values.coverUrl[0].url : infourl + "/" + values.coverUrl[0].response.key,
          courseUrl: values.courseUrl,
        };
        if (typeQ === "edit") {
          params.id = detailObj.id;
        } else {
          delete params.id;
        }
        let url = typeQ === "add" ? "paycourse/save" : "paycourse/update";
        axios.post(url, params).then((res) => {
          if (res.data.code !== "200") return message.error(res.data.msg);
          message.success(`${typeQ === "add" ? "新增" : "编辑"}成功`);
          this.setState({ showKnowName: false, detailObj: {}, coverUrl: "" });
          this.props.form.resetFields();
          this.InitClassHandle();
        });
      }
    });
  };
  handleChangefile = ({ file, fileList }, type) => {
    if (file.status === "uploading") {
      this.setState({ [type + "loading"]: true });
      return;
    }
    if (file.percent === 100) {
      if (file.status === "done") {
        let url = type === "fileList" ? this.state.infourl + "/" + fileList[0].response.hash : fileList[0].response.data.url;
        // let fileL = {
        // 	uid: fileList[0].uid,
        // 	name: fileList[0].name,
        // 	status: fileList[0].status,
        // 	url: url,
        // 	type: fileList[0].type
        // }
        this.setState({ uid: fileList[0].uid, name: fileList[0].name, type: fileList[0].type, coverUrl: url, [type + "loading"]: false });
      } else if (file.status === "removed") {
        this.setState({ coverUrl: "", [type + "loading"]: false });
      }
    }
  };
  cancelForm = () => {
    this.props.form.resetFields();
    this.setState({ showKnowName: false, coverUrl: "", detailObj: {} });
  };
  normFile = (e) => {
    if (e.fileList.length === 2) {
      e.fileList = e.fileList.slice(-1);
      message.warning("一个版本只能上传一个文件");
    }
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  render() {
    let { dataSource, columns, total, pageNum, typeQ, showKnowName, detailObj } = this.state;
    const { getFieldDecorator } = this.props.form;
    const courseButton = (
      <div>
        <Icon type={this.state.fileListloading ? "loading" : "plus"} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <div>
        <span className="header-name">视频课资料管理</span>
        <Divider />
        <div className="search-center">
          <Input
            placeholder="搜索资源名称"
            value={this.state.courseName}
            onChange={(e) => {
              this.setState({ courseName: e.target.value });
            }}
          />
          <Select
            placeholder="选择学科"
            size={"large"}
            value={this.state.subjectId}
            allowClear
            style={{ width: 180, marginRight: "20px" }}
            onChange={(value) => {
              this.setState({
                subjectId: value,
              });
            }}>
            {this.state.optionList.map((item) => {
              return (
                <Option key={item.subjectId + item.subjectName} value={item.subjectId}>
                  {item.subjectName}
                </Option>
              );
            })}
          </Select>
          <Select
            placeholder="置顶状态"
            size={"large"}
            value={this.state.isTop}
            allowClear
            style={{ width: 140, marginRight: "20px" }}
            onChange={(value) => {
              this.setState({
                isTop: value,
              });
            }}>
            <Option value="false">未置顶</Option>
            <Option value="true">已置顶</Option>
          </Select>
          <Button
            className="my-button-primary"
            type="primary"
            onClick={() => {
              this.InitClassHandle();
            }}>
            搜索
          </Button>
          <Button
            className="zip-left"
            onClick={() => {
              this.ClearKnow();
            }}>
            重置
          </Button>
          <Button
            className="my-button-primary rig-btn"
            type="primary"
            onClick={() => {
              this.handleKnow("add", {});
            }}>
            新增资源
          </Button>
        </div>
        <div>
          <DndProvider backend={HTML5Backend}>
            <Table dataSource={dataSource} columns={columns} pagination={false} rowKey={(record) => record.id} />
            <Pagination
              className="table-pagination"
              total={total}
              current={pageNum}
              showSizeChanger
              showQuickJumper
              pageSizeOptions={["10", "20", "50", "100"]}
              onChange={this.pageChange}
              onShowSizeChange={this.sizeChange}
            />
          </DndProvider>
          <Modal title={`${typeQ === "add" ? "新增" : "编辑"}资源`} width="500px" className="pay-modal" visible={showKnowName} onOk={this.submitOk} onCancel={this.cancelForm}>
            <Form labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} onSubmit={this.submitOk}>
              <FormItem label="学科" name="subjectId">
                {getFieldDecorator("subjectId", {
                  rules: [{ required: true, message: "请选择学科" }],
                  initialValue: typeQ === "edit" ? detailObj.subjectId : undefined,
                })(
                  <Select placeholder="选择学科">
                    {this.state.optionList.map((item) => {
                      return (
                        <Option key={item.subjectId + item.subjectName} value={item.subjectId}>
                          {item.subjectName}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </FormItem>
              <FormItem label="资源名称" name="courseName">
                {getFieldDecorator("courseName", {
                  rules: [
                    { required: true, message: "请输入资源名称" },
                    { max: 50, message: "最多输入50个字!" },
                  ],
                  initialValue: typeQ === "edit" ? detailObj.courseName : "",
                })(<Input showcount="true" maxLength={50} />)}
              </FormItem>
              <FormItem label="资源封面" name="coverUrl">
                {getFieldDecorator("coverUrl", {
                  rules: [{ required: true, message: "请选择资源封面" }],
                  valuePropName: "fileList",
                  getValueFromEvent: this.normFile,
                })(
                  <Upload
                    accept=".jpg, .png, .jpeg"
                    listType="picture-card"
                    className="course-pic"
                    action={qiniuUpUrl}
                    showUploadList={false}
                    beforeUpload={(file, fileList) => {
                      const isLt10M = file.size / 1024 / 1024 <= 2;
                      if (!isLt10M) {
                        return message.error("文件大小限制在2M以下！");
                      }
                    }}
                    onChange={(e) => {
                      this.handleChangefile(e, "fileList");
                    }}
                    data={{ token: this.state.token }}>
                    {/* {uploadButton} */}
                    {this.state.coverUrl ? <img src={this.state.coverUrl} alt="avatar" /> : courseButton}
                  </Upload>
                )}
                <p style={{ fontSize: "12px", color: "#ccc", marginTop: "-25px" }}>仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：750*426px</p>
              </FormItem>

              <FormItem label="资源链接" name="courseUrl">
                {getFieldDecorator("courseUrl", {
                  rules: [{ required: true, message: "请输入资源链接" }],
                  initialValue: typeQ === "edit" ? detailObj.courseUrl : "",
                })(<Input placeholder="请输入资源链接" />)}
              </FormItem>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }
}
export default Form.create()(PayClass);
